<div
  class="badge {{ variant ? 'badge-' + variant : '' }}"
  [ngClass]="{
    'badge--unbreakable': unbreakable,
  }"
>
  {{ label }}
</div>
